import { Component, ViewEncapsulation } from "@angular/core";
import { MCBarSkeletonComponent, MCCircleSkeletonComponent } from "@maslul/common-components";

@Component({
    selector: 'mi-approval-type-method-skeleton',
    templateUrl: './skeleton.html',
    styleUrls: ['./skeleton.scss'],
    standalone: true,
    imports: [
        MCCircleSkeletonComponent,
        MCBarSkeletonComponent
    ],
    encapsulation: ViewEncapsulation.None
})
export class ApprovalTypeMethodSkeletonComponent {


}
